import { DefaultRootState, useSelector } from 'react-redux';
import { ResultsState } from '../Results/store/reducers';
import { CheckoutState } from '../Checkout/store/reducers';
import { FareGroupsCompareTableQueryVariables } from '@websky/graphql';
import { useMemo } from 'react';
import { Log } from '../sentry';
import { isResultsStateGuard, isCheckoutStateGuard } from '../typeguards';

const fareGroupCompareTableVariablesFactory = (
	state: DefaultRootState | ResultsState | CheckoutState,
	orderId?: string
): FareGroupsCompareTableQueryVariables => {
	const variables: FareGroupsCompareTableQueryVariables = {};

	if (!isResultsStateGuard(state) && !isCheckoutStateGuard(state)) {
		Log({
			message: 'CompareFares: undefined state',
			data: state,
			level: 'error'
		});

		return variables;
	}

	if (isCheckoutStateGuard(state) || orderId) {
		variables.flightId = null;
		variables.orderId = orderId ?? (state as CheckoutState).order.id;
		variables.iata = null;
	} else if (isResultsStateGuard(state)) {
		variables.orderId = null;
		if (state.legInView) {
			const fareGroupWithFlightId = state.legInView.pricesForFareGroups?.find(
				priceForFareGroup => priceForFareGroup?.prices?.[0]?.flight?.id
			);

			variables.flightId = fareGroupWithFlightId?.prices?.[0]?.flight?.id;
			variables.iata = null;
		} else if (state.selectedFares.length) {
			variables.flightId = state.selectedFares[0].flightInfo.id;
			variables.iata = null;
		}
	}

	return variables;
};

export const useCompareFaresModel = (
	orderId?: string
): {
	compareTableVariables: FareGroupsCompareTableQueryVariables;
} => {
	const state = useSelector(state => state);
	const compareTableVariables = useMemo(() => fareGroupCompareTableVariablesFactory(state, orderId), [
		state,
		orderId
	]);

	return {
		compareTableVariables
	};
};
